import { createFileRoute } from "@tanstack/react-router";
import { seoHead } from "@/lib/seo/head";
import AdminGate from "@/components/AdminGate";
import AdminEmailAuth from "@/pages/AdminEmailAuth";

export const Route = createFileRoute("/admin/email-auth")({
  head: () => seoHead("/admin/email-auth"),
  component: () => (
    <AdminGate>
      <AdminEmailAuth />
    </AdminGate>
  ),
});